import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import KpiButton from './KpiButton';
import styles from '../index.module.css';
import { RootState } from '../../../app/store';
import useFetchVideoStats from '../../../hooks/useFetchVideoStats';
import { useKpiStats } from '../../../hooks/useKpiStats';
import { setScheduled, setSubtitleUpdated, setUploaded } from '../../../features/filters/filterSlice';

interface Props {
    title: string;
    type: 'video' | 'notes';
}

const KpiSection: React.FC<Props> = ({ title, type }) => {
    const dispatch = useDispatch();
    const { from, to, center, uploaded, scheduled, subtitleUpdated } = useSelector(
        (state: RootState) => state.filter
    );

    const { statsData } = useFetchVideoStats(from, to, center, type);
    const kpis = useKpiStats(statsData);

    return (
        <div className={styles.section}>
            <h3 className={styles['section-title']}>{title}</h3>

            <div className={styles['kpi-container']}>
                <KpiButton title="Total" value={kpis.total} activeClass="" inactiveClass="" />

                <KpiButton
                    title="Not Uploaded"
                    value={`${kpis.notUploaded} (${kpis.notUploadedPct}%)`}
                    active={uploaded === -1}
                    activeClass="red-active"
                    inactiveClass="red-inactive"
                    onClick={() => dispatch(setUploaded(uploaded === -1 ? 0 : -1))}
                />

                <KpiButton
                    title="Uploaded"
                    value={`${kpis.uploaded} (${kpis.uploadedPct}%)`}
                    active={uploaded === 1}
                    activeClass="green-active"
                    inactiveClass="green-inactive"
                    onClick={() => dispatch(setUploaded(uploaded === 1 ? 0 : 1))}
                />

                <KpiButton
                    title="Not Scheduled"
                    value={`${kpis.notScheduled} (${kpis.notScheduledPct}%)`}
                    active={scheduled === -1}
                    activeClass="red-active"
                    inactiveClass="red-inactive"
                    onClick={() => dispatch(setScheduled(scheduled === -1 ? 0 : -1))}
                />

                <KpiButton
                    title="Scheduled"
                    value={`${kpis.scheduled} (${kpis.scheduledPct}%)`}
                    active={scheduled === 1}
                    activeClass="green-active"
                    inactiveClass="green-inactive"
                    onClick={() => dispatch(setScheduled(scheduled === 1 ? 0 : 1))}
                />

                {type === 'video' && (
                    <>
                        <KpiButton
                            title="Thumbnail Not Automated"
                            value={`${kpis.subtitleNotUpdated} (${kpis.subtitleNotUpdatedPct}%)`}
                            active={subtitleUpdated === -1}
                            activeClass="red-active"
                            inactiveClass="red-inactive"
                            onClick={() => dispatch(setSubtitleUpdated(subtitleUpdated === -1 ? 0 : -1))}
                        />

                        <KpiButton
                            title="Thumbnail Automated"
                            value={`${kpis.subtitleUpdated} (${kpis.subtitleUpdatedPct}%)`}
                            active={subtitleUpdated === 1}
                            activeClass="green-active"
                            inactiveClass="green-inactive"
                            onClick={() => dispatch(setSubtitleUpdated(subtitleUpdated === 1 ? 0 : 1))}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default KpiSection;
